import KonfigurasiAngket from "../../../../../components/categories/siakad/laporan_adab/konfigurasi-angket/Home"
export default function Home() {
  
  return (
    <KonfigurasiAngket />
  );
}
